import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";
import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import WebdoctorSlider from './WebdoctorSlider';
import { Helmet } from 'react-helmet';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class DoctorManagment extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="layout-wrapper">
              <Helmet>
                <title>Doctor Management Software for Clinics | KlinicQ</title>
                <meta 
                  name="description" 
                  content="Streamline doctor scheduling, consultations, availability tracking, and performance management with KlinicQ’s cloud-based doctor management software for clinics and hospitals." 
                />

                <script type="application/ld+json">
                  {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "SoftwareApplication",
                    "name": "KlinicQ Doctor Management Software",
                    "applicationCategory": "MedicalBusiness",
                    "operatingSystem": "Web",
                    "description": "Cloud-based doctor management software by KlinicQ for managing doctor schedules, appointments, availability, and clinical workflows efficiently.",
                    "url": "https://klinicq.com/doctormanagement",
                    "provider": {
                      "@type": "Organization",
                      "name": "KlinicQ"
                    }
                  })}
                </script>
              </Helmet>


                <div className="main-content">
                   
                    <div className="mainpage">
                      

<div className='product-section'>
    <Headerweb/>

            {/* <hr className='m-0' style={{ color: '#D9F4FF' }} /> */}
             <section id="pharma-hero-section">
  <div className="pharma-hero-background">
    <div className="docmang-hero-gradient"></div>
    <img
      src={require("../../src/assets/images/website/doctor-management-system-clinical-dashboard-healthcare.webp")}
      alt="Doctor management software dashboard for clinics and hospitals"
      className="pharma-hero-bg-image"
    />
  </div>
  <div className="pharma-container pharma-hero-content-container">
    <div className="pharma-hero-text">
      <h1>Doctor Management System</h1>
      <p>
        The Doctor Management module enables hospitals and clinics to efficiently organize doctor profiles, schedules, and availability. It centralizes key information such as specialization, consultation hours, assigned departments, and patient feedback—making it easy for both staff and patients to connect with the right medical professionals.
      </p>
    </div>
   
  </div>
</section>

    <div id="hospitalmang-feature-one">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/doctor-management-system-clinical-dashboard-healthcare.webp")} alt="Doctor using digital doctor management system to manage schedules and consultations" />
      </div>
   <div class="hospitalmang-feature-text-wrapper">
  <p>
    The doctor portal is designed to support physicians across all specialties. It includes detailed information such as educational qualifications, specialization areas, hospital affiliations, working hours, and consultation modes—Token Management System, Appointment Management System, and Tele-consultation.
  </p>
  <p>
    Our Clinical Management System efficiently manages physician schedules based on availability. Since the KlinicQ application is a cloud-based solution hosted on AWS (Amazon Web Services), physicians can securely access hospital-assigned data from anywhere.
  </p>
  <p>
    Recognizing that consultation time varies per patient, the KlinicQ token management system uses takt time instead of cycle time to calculate appointment durations. Hospitals and clinics can configure their cycle time in the dashboard based on specialty and historical consultation data.
  </p>
  <p>
    The Clinical Management System is fully integrated, allowing physicians to send follow-up instructions to nurses and admin staff, and prescriptions directly to the pharmacy. It supports bi-directional communication between laboratories and hospitals for sending test requests and receiving lab results.
  </p>
  <p>
    Follow-up appointment reminders can be automatically sent to patients, improving engagement and continuity of care.
  </p>
</div>


    </div>
  </div>
</div>

<div id="hospitalmang-feature-two">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
    <div class="hospitalmang-feature-text-wrapper">
  <p>
    Analytical insights are powerful tools for business growth. Our Clinical Management System includes a wide range of KPI reports and trend analyses—covering average waiting times, consultation durations, clinical records, pharmacy data, and laboratory reports—to help optimize operations and support critical decision-making.
  </p>
  <p>
    Since consultation time varies per patient, the KlinicQ token management system uses takt time instead of cycle time to calculate appointment durations. Each hospital or clinic can configure its cycle time in the dashboard based on specialty and historical consultation data.
  </p>
  <p>
    The KlinicQ application supports walk-in appointments, mobile app check-ins, and teleconsultations. It enables referral management between physicians and allows prescriptions to be sent directly to the selected pharmacy. Hospitals and clinics can link their associated pharmacy or laboratory for seamless prescription and test request handling.
  </p>
  <p>
    During the check-in process, staff can update patient vitals, visit reasons, and medical conditions. Physicians can then review these details and update diagnoses with just a few clicks. The KlinicQ database includes thousands of medicines for quick prescribing, and clinics can add their own drug records using simple drug IDs for easy selection.
  </p>
  <p>
    Patients can digitally access their medical records, previous prescriptions, discharge summaries, and vital consultation history. Physicians can send automated follow-up reminders, and the integrated payment gateway supports secure online transactions.
  </p>
</div>



      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/clinical-reporting-system-medical-data-infographic.webp")} alt="Doctors reviewing patient records using clinical management software" />
      </div>
    </div>
  </div>

</div>
  <div className='logo-slider container-90 slide-right visible'>
          <WebdoctorSlider />
        
        </div>
        <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
            <img
            src={require("../../src/assets/images/website/online-doctor-consultation-digital-healthcare-app-1200.webp")}
            srcSet={`
                ${require("../../src/assets/images/website/online-doctor-consultation-digital-healthcare-app-768.webp")} 768w,
                ${require("../../src/assets/images/website/online-doctor-consultation-digital-healthcare-app-1200.webp")} 1200w,
            `}
            sizes="(max-width: 1200px) 100vw, 1053px"
            className="foreground-image1"
            alt="Online doctor consultation using a digital healthcare mobile app"
            loading="lazy"
            />

            </div>
            </div>
          </div>
        </div>
        <div>
          </div>
              
            {/* </section> */}
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
   
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(DoctorManagment);